import { styled } from "@mui/material/styles";
import { Box, Typography, Paper, TableCell } from "@mui/material";

export const PageContainer = styled(Box)(({ theme }) => ({
    minHeight: "20vh",
    color: "black",
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
}));

export const HeaderTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1.5),
    color: "black",
    fontSize: "1 rem",
    fontWeight: 500,
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius,
}));

export const StyledTableContainer = styled(Box)(() => ({
    width: "100%",
    overflowX: "auto",
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(1),
    fontSize: "0.8rem",
    borderBottom: "1px solid #d0d0d0",
}));

export const SystemNoteContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1.5),
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
}));

export const FooterNote = styled(Typography)(({ theme }) => ({
    marginTop: theme.spacing(1.5),
    color: "black",
    fontSize: "0.7rem",
}));
